/**
 * `?model=` 事前選択 (AI俳優一覧「キャスティング」ボタンからの遷移) の共通完了・失敗条件判定。
 * ScenarioGenerator.tsx (動画・1-a) / GenerationWorkspace.tsx (静止画・1-b) の双方が使う
 * (docs/features/character-casting-consistency-plan.md 修正1)。
 *
 * `usePromptModels({ ids: [modelParam] })` の単体解決クエリの結果を、
 * 「読み込み中 / 対象なし (権限外・削除済み) / クエリエラー / 解決成功」の4状態に正規化する。
 */
export type ModelParamQueryOutcome<T> =
  | { kind: 'loading' }
  | { kind: 'error' }
  | { kind: 'not_found' }
  | { kind: 'found'; target: T };

export function resolveModelParamQueryOutcome<T extends { id: string }>(
  modelParam: string,
  query: { data: T[] | undefined; isError: boolean },
): ModelParamQueryOutcome<T> {
  if (query.isError) return { kind: 'error' };
  if (!query.data) return { kind: 'loading' };
  const target = query.data.find((m) => m.id === modelParam);
  return target ? { kind: 'found', target } : { kind: 'not_found' };
}
